import { fetcher } from '@commenda/utils';
import { BulkUploadResponse } from '../products/types';
import { BulkUploadTransactionsParams } from './types';

export async function bulkUploadTransactions(
  body: BulkUploadTransactionsParams,
  token: string
): Promise<{
  success: boolean;
  data?: BulkUploadResponse;
  error?: string;
}> {
  try {
    // Strip signedUrl from file object - backend doesn't accept it
    const { signedUrl: _, ...fileWithoutSignedUrl } = body.file;
    const sanitizedBody = {
      ...body,
      file: fileWithoutSignedUrl,
    };

    const response = await fetcher(
      `new-sales-tax/transactions/bulk/csv`,
      { method: 'POST', body: sanitizedBody },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error uploading transactions:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to upload transactions',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to upload transactions';
    console.error('Failed to upload transactions:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}
